import { Injectable } from '@angular/core';

import Gleap from 'gleap';

import { environment } from '../../../environments/environment';
import { User } from '../auth';

@Injectable({
  providedIn: 'root',
})
export class CustomerFeedbackService {
  initialize(user: User): void {
    Gleap.showFeedbackButton(!!user?.id);

    if (!user?.id) return;

    Gleap.initialize(environment.GLEAP_API_KEY);

    Gleap.identify(`${user.id}`, {
      name: user.fullName,
      email: user.email,
      companyName: user.companyName,
    });
  }
}
